import * as React from 'react'
import styled, { css } from 'styled-components'
import { theme } from 'utils/styledHelper'

interface SvgPropsType {
  selectable: number
  size?: string
}

const themeColorTemplate = css<SvgPropsType>`
  fill: ${theme('iconColor')};
  cursor: ${(props) => (props.selectable === 1 ? 'pointer' : 'default')};
  &:hover {
    fill: ${(props) =>
      props.selectable === 1 ? theme('iconHoverColor')(props) : theme('iconColor')(props)};
  }
`

const svgColorTemplate = css<SvgPropsType>`
  cursor: ${(props) => (props.selectable === 1 ? 'pointer' : 'default')};
`

export default (Svg, name: string, keepSvgColor = false) => {
  const template = keepSvgColor ? svgColorTemplate : themeColorTemplate
  const Icon = styled(Svg)<SvgPropsType>`
    ${template};
  `

  interface Props {
    onClick?: () => void
    selectable?: boolean
    size?: string
  }
  const WithStyle = (props: Props) => {
    const { selectable, size, ...rest } = props

    return (
      <Icon
        {...rest}
        height={size ?? '44px'}
        selectable={selectable ?? false ? 1 : 0}
        width={size}
      />
    )
  }

  return WithStyle
}
